import { ListDto } from '@pharmac-extranet/extranet-api'
import { InfiniteData } from '@tanstack/react-query'

export const getPages = <T>(data: undefined | InfiniteData<ListDto & { data?: T[] }>) => {
  if (!data || !data.pages || data.pages.length === 0) return []

  return data.pages.reduce<T[]>((acc, curr) => acc.concat(curr.data ?? []), [])
}
